/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import { convertToId } from '@/helpers/tools';

export class AddressContact extends BaseModel {
    defaults() {
        return {
            id: null,
            main_address_id: null,
            contact_address_id: null,
            relation_function: null,
            is_main_contact: null,
            publish_frontend: null,

            // view props:
            main_address_title: null,
            main_address_legal_type: null,
            contact_address_title: null,
            contact_address_legal_type: null,
        };
    }

    mutations() {
        return {
            id: convertToId,
            main_address_id: convertToId,
            contact_address_id: convertToId,
            is_main_contact: Boolean,
            publish_frontend: Boolean,
        };
    }

    entityName() {
        return 'addressContact';
    }
}

export class AddressContactCollection extends BaseCollection {
    options() {
        return {
            model: AddressContact,
        };
    }

    entityName() {
        return 'addressContact';
    }
}
